export const types = <const>{
	mutations: {
		BARVA_LAK_DRUH_SELECT_MAPPER: 'BARVA_LAK_DRUH_SELECT_MAPPER',
	},
};
